module.exports = __webpack_public_path__ + "img/3.af0e2b91.jpg";